module.exports = __webpack_public_path__ + "static/media/alcenor.f468388b.png";